import { Component, OnInit } from '@angular/core';

import { BaseControlComponent } from "../../../../../../form-controls/components/base-control/base-control.component";
import { ContextInteractionService } from '../../../../../../form-controls/services/context-interaction.service';
import { applyFroalaAriaFix, stripFroalaWatermark } from '../../../../../../common/utils/froala.utils';


@Component({
    selector: 'app-e-signature-display-config',
    templateUrl: './e-signature-display-config.component.html',
    standalone: false
})
export class ESignatureDisplayConfigComponent extends BaseControlComponent implements OnInit {
    static componentName = "ESignatureDisplayConfigComponent";

    private _froalaOptions: any = null;
    get froalaOptions(): any {
        if (!this._froalaOptions) {
            this._froalaOptions = applyFroalaAriaFix({
                key: this.editorKey,
                heightMax: 300,
                heightMin: 150,
                toolbarButtons: ["fullscreen", "html", "|", "undo", "redo", "|", "bold", "italic", "underline", 'strikeThrough', "|", "formatOL", "formatUL", "|", "align", "fontSize", "paragraphFormat", "insertLink", "|", "outdent", "indent", "clearFormatting", "insertTable", "color"]
            });
        }
        return this._froalaOptions;
    }

    constructor(public readonly contextService: ContextInteractionService) { super(contextService); }

    onLegalFooterChange(): void {
        this.componentData.config.display.legalFooter = stripFroalaWatermark(this.componentData.config.display.legalFooter);
    }

    ngOnInit() {
        super.ngOnInit();

    }

}
